import { Camera, MessageSquareHeart, MapPin, Video } from "lucide-react";

const examples = [
  { icon: Camera, text: "住房照片" },
  { icon: Video, text: "短影音" },
  { icon: MapPin, text: "打卡" },
  { icon: MessageSquareHeart, text: "心得評論" },
];

const Dots = ({ n, color }) => (
  <div className="flex flex-wrap gap-1.5">
    {Array.from({ length: n }).map((_, i) => (
      <span key={i} className="grid h-8 w-8 place-items-center rounded-full text-white" style={{ background: color }}><Camera size={14} /></span>
    ))}
  </div>
);

const Bar = ({ label, parts, total, testid }) => (
  <div data-testid={testid}>
    <div className="flex justify-between text-sm"><span className="font-bold text-[var(--ink)]">{label}</span><span className="font-black text-[var(--ink)]">{total}</span></div>
    <div className="mt-2 flex h-9 overflow-hidden rounded-full bg-[var(--line)]">
      {parts.map((p) => (
        <div key={p.label} className="flex items-center justify-center text-xs font-bold text-white" style={{ width: p.w, background: p.color }}>{p.label}</div>
      ))}
    </div>
  </div>
);

export const BonusUGC = () => (
  <div className="mt-6 grid gap-6 lg:grid-cols-2">
    <div className="rounded-3xl bg-[var(--warm)] p-7">
      <p className="text-sm font-black text-[var(--teal-d)]">UGC 是什麼？</p>
      <p className="mt-2 text-lg font-bold text-[var(--ink)]">不是飯店官方發的，而是「客人自己」拍照、打卡、寫心得、發影片分享名人堂。</p>
      <div className="mt-5 grid grid-cols-4 gap-2">
        {examples.map((e) => (
          <div key={e.text} className="rounded-xl bg-white p-3 text-center">
            <e.icon size={22} className="mx-auto text-[var(--teal-d)]" />
            <p className="mt-1 text-xs font-bold text-[var(--text)]">{e.text}</p>
          </div>
        ))}
      </div>
      <p className="mt-5 text-sm text-[var(--text)]">過去經驗：只要開始做，UGC 會變成原本的 <b className="text-[var(--teal-d)]">3 倍</b>。</p>
      <div className="mt-4 grid grid-cols-[auto_1fr] items-center gap-x-4 gap-y-3">
        <span className="text-sm font-bold text-[var(--muted)]">之前</span><Dots n={3} color="#B8B2AB" />
        <span className="text-sm font-bold text-[var(--teal-d)]">之後</span><Dots n={9} color="#47BBBC" />
      </div>
    </div>
    <div className="rounded-3xl border border-[var(--line)] p-7">
      <p className="text-sm font-black text-[var(--teal-d)]">曝光前後差異（每月）</p>
      <p className="mt-2 text-lg font-bold text-[var(--ink)]">光是跟官方直接合作的內容帶出的 UGC，就能再多一倍的 Mere Exposure。</p>
      <div className="mt-6 space-y-5">
        <Bar testid="ugc-bar-before" label="只有廣告" total="約 432 萬" parts={[{ label: "一般曝光等值 432 萬", w: "50%", color: "#E85A1A" }]} />
        <Bar testid="ugc-bar-after" label="廣告 + UGC" total="約 865 萬" parts={[{ label: "432 萬", w: "50%", color: "#E85A1A" }, { label: "+ UGC 432 萬", w: "50%", color: "#47BBBC" }]} />
      </div>
      <p className="mt-5 text-sm text-[var(--muted)]">換算：4,324,660 × 2 ≈ 8,649,320 次／月</p>
    </div>
  </div>
);
